import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { RoomType } from "../schema/UpdateRoomSchema";
import { updateRoomResponseSchema } from "../response/UpdateRoomResponse";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";

export const useUpdateRoom = () => {
    return useMutation({
        mutationFn: async (values: {
            bookingId: string;
            formData: RoomType;
        }) => privateApi.post(`/v3/booking/${values.bookingId}/room`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = updateRoomResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update room data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update room', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid room data format");
            } else {
                console.error('Failed to update room', error);
                throw error;
            }
        },
    });
};